// src/actions/checkout/placeorderActions.js
import { SubscribeCouponApi } from "../../api/subscribe/subcribeCouponApi";
import { SUBSCRIBE_COUPON_SUCCESS, SUBSCRIBE_COUPON_FAILURE, CLEAR_COUPON_SUBSCRIBE } from "../types";

export const subcribeCouponSuccess = (placeorder) => ({
  type: SUBSCRIBE_COUPON_SUCCESS,
  payload: placeorder,
});

export const subcribeCouponFailure = (error) => ({
  type: SUBSCRIBE_COUPON_FAILURE,
  payload: error,
});

export const subcribeCouponOrder = (error) => ({
  type: CLEAR_COUPON_SUBSCRIBE,
});

export const getSubcribeCoupon = (postData) => {
  return (dispatch) => {
    SubscribeCouponApi(postData)
      .then((response) => {
        dispatch(subcribeCouponSuccess(response.data));
      })
      .catch((error) => {
        console.log("error");
        console.log(error);
        dispatch(subcribeCouponFailure(error.message));
      });
  };
};
